<template>
  <div
    class="psui-el-switch"
    :class="[getComponentClass, { disabled: disabled }]"
    @click.prevent="change()"
    @keydown.enter.stop="change()"
    :tabindex="tabindex"
  >
    <span
      class="psui-el-switch-button"
      :class="[getToggleClass]"
    />
    <input
      type="checkbox"
      :checked="value"
      :id="uniqueId"
      tabindex="-1"
      :aria-label="label || null"
    >
  </div>
</template>

<script setup>
//FIGMA CONTROLS & SELECTORS https://www.figma.com/file/Tto8hrNlSfuPcwd1pfqogF/%E2%9A%A1%EF%B8%8F-Design-System?node-id=1768%3A64852
import { computed, getCurrentInstance } from 'vue'

const emit = defineEmits(['change', 'update:value'])

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  value: {
    type: Boolean,
  },
  backgroundColor: {
    type: String,
    default: 'psui-bg-green-20',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'big',
    validator: (value) => ['small', 'big'].includes(value),
  },
  tabindex: {
    type: [Number, String],
    default: 0,
  },
})

const getToggleClass = computed(() => {
  if (props.disabled) return 'toggle-false'
  return props.value ? `toggle-true ${props.backgroundColor}` : 'toggle-false psui-bg-gray-40'
})

const getComponentClass = computed(() => {
  return `size-${props.size}`
})

const instance = getCurrentInstance()
const uid = instance?.uid || Math.random().toString(36).slice(2)
const uniqueId = computed(() => `psui-switch-${uid}`)

const change = () => {
  if (props.disabled) return

  emit('update:value', !props.value)
  emit('change', !props.value)
}
</script>
